import { atom, useAtom } from 'jotai';
import { useCallback } from 'react';
// Atom to manage the state of collapsible items
const collapsibleStateAtom = atom({});
// Custom hook for managing collapsible items state
export function useCollapsibleItems() {
    const [openItems, setOpenItems] = useAtom(collapsibleStateAtom);
    const toggleItem = useCallback((label) => {
        setOpenItems((prev) => ({
            ...prev,
            [label]: !prev[label]
        }));
    }, [setOpenItems]);
    const openItem = useCallback((label) => {
        setOpenItems((prev) => ({
            ...prev,
            [label]: true
        }));
    }, [setOpenItems]);
    const closeItem = useCallback((label) => {
        setOpenItems((prev) => ({
            ...prev,
            [label]: false
        }));
    }, [setOpenItems]);
    const resetItems = useCallback(() => {
        setOpenItems({});
    }, [setOpenItems]);
    return { openItems, toggleItem, openItem, closeItem, resetItems };
}
